<template>
  <div class="flows-content">
    <el-container>
      <el-main style="margin-bottom: 20px; padding: 0">
        <el-container direction="vertical">
          <FlowHeader
            :isReadOnly="readOnly"
            :saveStatus="false"
            @saveSubmit="handleSubmit(1)"
            @sendSubmit="handleSubmit(2)"
            @handleBackEnd="handleSubmit(3)"
            @handleCC="handleSubmit(4)"
            @handleAssign="handleSubmit(5)"
            @handleBackUp="handleSubmit(6)"
            @handleAssist="handleSubmit(7)"
            @handleNode="handleSubmit(8)"
            @handleNodeImage="handleSubmit(9)"
            @handleCollection="handleSubmit(10)"
          />
          <el-main class="info">
            <div>
              <el-input
                v-model="title"
                class="flow-title"
                :disabled="$route.query.type * 1 !== 1"
                placeholder="请输入流程标题"
              />
            </div>
            <div class="info-top">
              <div class="left">
                <span>单据号码：{{ billCode }}</span>
                <span class="text">制单日期：{{ billDate }}</span>
              </div>
              <div class="right">
                <span>发起人：{{ applyPerson }}</span>
                <span class="text">状态：{{ taskTypeText[taskStatus * 1] }}</span>
              </div>
            </div>
            <div style="margin-top: 20px" class="table">
              <!-- 上半部分：申请人填写区域 -->
              <el-descriptions :column="2" border class="descriptions" label-width="200">
                <el-descriptions-item label="申请日期：">{{ formData.createTime }}</el-descriptions-item>
                <el-descriptions-item label="工程名称：">{{ formData.engineeringName }}</el-descriptions-item>
                <el-descriptions-item label="合同单位：">{{ formData.companyName }}</el-descriptions-item>
                <el-descriptions-item label="委托类型：">
                  <el-select
                    v-model="formData.delegationType"
                    placeholder="请选择委托类型"
                    clearable
                    filterable
                    disabled
                    @change="handleDelegationTypeChange"
                  >
                    <el-option
                      v-for="item in delegationTypeOptions"
                      :key="item.id"
                      :label="item.itemName"
                      :value="item.itemName"
                    />
                  </el-select>
                </el-descriptions-item>
                <el-descriptions-item label="交底类型：">{{ formData.discloseType }}</el-descriptions-item>
                <el-descriptions-item label="首次供应时间：">{{ formData.firstSupplyTime || '-' }}</el-descriptions-item>
                <el-descriptions-item label="委托日期：">{{ formData.entrustBeginTime }} ~ {{ formData.entrustEndTime }}</el-descriptions-item>
                <el-descriptions-item label="累计委托量：">{{ formData.commissionedQuantity }}</el-descriptions-item>
                <el-descriptions-item label="截至审核日已供方量（m³）：" :span="2">{{ formData.supplyQuantity }}</el-descriptions-item>
                <el-descriptions-item label="本次申请委托量（m³）：">
                  <el-input
                    v-model="formData.applyEntrustedVolume"
                    placeholder="请输入正整数"
                    disabled
                    @input="handlePositiveInteger('applyEntrustedVolume', $event)"
                  />
                </el-descriptions-item>
                <el-descriptions-item label="本次申请委托截至时间：">
                  <el-date-picker
                    v-model="formData.applyDeadlineDate"
                    type="date"
                    placeholder="选择日期"
                    value-format="yyyy-MM-dd"
                    disabled
                    style="width: 100%"
                  />
                </el-descriptions-item>
                <el-descriptions-item label="累计委托量（m³）">
                  {{ calculateTotalCommissioned(formData.commissionedQuantity, formData.applyEntrustedVolume) }}
                </el-descriptions-item>
                <el-descriptions-item label="查看管控参数">
                  <span><el-link :underline="false" @click="lookMore">查看</el-link></span>
                </el-descriptions-item>
                <el-descriptions-item
                  label="需办理委托原因与合同推进情况与预计签订时间简述:"
                  labelClassName="redFont"
                  contentClassName="textClass"
                  :span="2"
                >
                  <el-input
                    v-model="formData.argument"
                    disabled
                    placeholder="请输入"
                    type="textarea"
                    style="width: 100%"
                  />
                </el-descriptions-item>
                <el-descriptions-item label="附件：" :span="2">
                  <FileComponent
                    fileCode="settlementFile"
                    disabled
                    :files="files"
                    @deleteFile="deleteFile"
                    @uplodeSuccess="uploadSuccess"
                  />
                </el-descriptions-item>
              </el-descriptions>

              <!-- 核订单签订情况（主页） -->
              <span style="font-size: 18px; margin-top: 24px">核订单签订情况</span>
              <el-table
                :header-cell-style="{ background: '#f3f6f9' }"
                :cell-style="{ borderRight: 'none' }"
                border
                stripe
                style="width: 100%; margin-top: 12px"
                tooltip-effect="dark"
                :data="nuclearOrderTableData"
              >
                <el-table-column label="结算周期" align="center" width="200">
                  <template slot-scope="scope">
                    {{ scope.row.lastDueTime }} ~ {{ scope.row.currentDueTime }}
                  </template>
                </el-table-column>
                <el-table-column label="结算量" align="center" prop="settleAmount" width="120" />
                <el-table-column label="审核状态" align="center" width="120">
                  <template slot-scope="scope">
                    <span v-if="scope.row.settleStatus == 0">待结算</span>
                    <span v-if="scope.row.settleStatus == 1">待审核</span>
                    <span v-if="scope.row.settleStatus == 2">审核中</span>
                    <span v-if="scope.row.settleStatus == 3">审核不通过</span>
                    <span v-if="scope.row.settleStatus == 4">审核通过</span>
                  </template>
                </el-table-column>
                <el-table-column label="附件" align="center">
                  <template slot-scope="scope">
                    <el-link v-if="scope.row.enclosureUrl" type="primary" :underline="false" @click="viewAttachment(scope.row.enclosureUrl)">查看附件</el-link>
                    <span v-else>-</span>
                  </template>
                </el-table-column>
                <el-table-column label="操作" align="left" width="120">
                  <template slot-scope="scope">
                    <el-button size="mini" class="bottom_two" @click="openSettlementDetail(scope.row)">查看</el-button>
                  </template>
                </el-table-column>
              </el-table>

              <!-- 领导审批参数区域 -->
              <span v-if="taskType != 1" style="font-size: 18px">领导审批参数</span>
              <el-button v-if="taskType != 1" style="margin-left: 24px" size="medium" :class="confirmStatus ? 'bottom_all' : 'bottom_two'" @click="confirmStatus = true">
                {{ confirmStatus ? '已确认' : '请确认' }}
              </el-button>
              <el-descriptions v-if="taskType != 1" :column="2" border class="descriptions" label-width="200" style="margin-bottom: 24px;margin-top:12px">
                <el-descriptions-item v-if="taskType != 1" label="本次申请委托时间：" labelClassName="redFont">
                  <el-date-picker
                    v-model="formData.leaderDeadlineDate"
                    style="width: 150px"
                    type="date"
                    unlink-panels
                    value-format="yyyy-MM-dd"
                    :disabled="confirmStatus"
                  />
                </el-descriptions-item>
                <el-descriptions-item v-if="taskType != 1" label="本次申请累计委托量（m³）" labelClassName="redFont">
                  <el-input
                    v-model="formData.leaderEntrustedVolume"
                    placeholder="请输入正整数"
                    style="width: 100%"
                    :disabled="confirmStatus"
                    @input="handlePositiveInteger('leaderEntrustedVolume', $event)"
                  />
                </el-descriptions-item>
                <el-descriptions-item v-if="taskType != 1" label="累计委托量（m³）" labelClassName="redFont">
                  {{ calculateTotalCommissioned(formData.commissionedQuantity, formData.leaderEntrustedVolume) }}
                </el-descriptions-item>
              </el-descriptions>

              <!-- 历史申请流程 -->
              <span style="font-size: 18px">历史申请流程</span>
              <el-table
                :header-cell-style="{ background: '#f3f6f9' }"
                :cell-style="{ borderRight: 'none' }"
                border
                stripe
                style="width: 100%; margin-top: 12px"
                tooltip-effect="dark"
                :data="removeControlTableData"
              >
                <el-table-column label="申请时间" align="center" prop="createTime" width="160" />
                <el-table-column label="申请人" align="center" prop="createUserName" width="70" />
                <el-table-column label="历史累计委托量" align="center" prop="commissionedQuantity" width="auto" />
                <el-table-column label="累计供应量" align="center" prop="supplyQuantity" width="auto" />
                <el-table-column label="本次委托截止时间" align="center" prop="applyDeadlineDate" width="100" />
                <el-table-column label="本次申请委托量" align="center" prop="applyEntrustedVolume" width="160" />
                <el-table-column label="累计委托量" align="center" prop="lastCommissionedQuantity" width="160" />
                <el-table-column label="流程完成时间" align="center" prop="approvalTime" width="160" />
                <el-table-column label="审批状态" align="center" prop="approvalStatus" width="160">
                  <template slot-scope="scope">
                    <span v-if="scope.row.approvalStatus == 0">待审核</span>
                    <span v-if="scope.row.approvalStatus == 1">已确认</span>
                    <span v-if="scope.row.approvalStatus == 2">审核通过</span>
                    <span v-if="scope.row.approvalStatus == 3">审批中</span>
                    <span v-if="scope.row.approvalStatus == 4">审核失败</span>
                    <span v-if="scope.row.approvalStatus == 5">撤销</span>
                  </template>
                </el-table-column>
                <el-table-column label="操作" align="left" width="220">
                  <template slot-scope="scope">
                    <el-button size="mini" class="bottom_two" @click="lookDetail(scope.row)">查看</el-button>
                    <el-button size="mini" class="bottom_two" @click="printApproval(scope.row)">打印审批表</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div class="flows-details">
              <FlowContent
                ref="flowcontent"
                :title="title"
                :dataForm="formData"
                :showSendVisible="showSendVisible"
                @handleCancel="handleCancel"
                @sendCode="sendCode"
                @sendProcessManagerId="sendProcessManagerId"
                @sendProcessVersionId="sendProcessVersionId"
                @handleFinish="handleFinish"
                @handleBusiness="handleBusiness"
                @resetFlowState="resetFlowState"
              />
            </div>
          </el-main>
        </el-container>
      </el-main>

      <!-- 历史记录明细弹窗 -->
      <el-dialog :visible.sync="historyDetailDig" width="1080px" :close-on-click-modal="false">
        <span slot="title" class="dialog-title">申请解控详情</span>
        <el-descriptions :column="2" border class="descriptions" label-width="200">
          <el-descriptions-item label="申请日期：">{{ historyDetailForm.createTime }}</el-descriptions-item>
          <el-descriptions-item label="工程名称：">{{ historyDetailForm.engineeringName }}</el-descriptions-item>
          <el-descriptions-item label="合同单位：">{{ historyDetailForm.companyName }}</el-descriptions-item>
          <el-descriptions-item label="委托类型：">{{ historyDetailForm.delegationType }}</el-descriptions-item>
          <el-descriptions-item label="交底类型：">{{ historyDetailForm.discloseType }}</el-descriptions-item>
          <el-descriptions-item label="首次供应时间：">{{ historyDetailForm.firstSupplyTime || '-' }}</el-descriptions-item>
          <el-descriptions-item label="委托日期：">{{ historyDetailForm.entrustBeginTime }} ~ {{ historyDetailForm.entrustEndTime }}</el-descriptions-item>
          <el-descriptions-item label="累计委托量：">{{ historyDetailForm.commissionedQuantity }}</el-descriptions-item>
          <el-descriptions-item label="截至审核日已供方量（m³）：" :span="2">{{ historyDetailForm.supplyQuantity }}</el-descriptions-item>
          <el-descriptions-item label="本次申请委托量（m³）：">{{ historyDetailForm.applyEntrustedVolume }}</el-descriptions-item>
          <el-descriptions-item label="本次申请委托截至时间：">{{ historyDetailForm.applyDeadlineDate }}</el-descriptions-item>
          <el-descriptions-item label="累计委托量（m³）">{{ calculateTotalCommissioned(historyDetailForm.commissionedQuantity, historyDetailForm.applyEntrustedVolume) }}</el-descriptions-item>
          <el-descriptions-item label="查看管控参数">
            <span><el-link :underline="false" @click="lookMore">查看</el-link></span>
          </el-descriptions-item>
          <el-descriptions-item
            label="需办理委托原因与合同推进情况与预计签订时间简述:"
            labelClassName="redFont"
            contentClassName="textClass"
            :span="2"
          >
            <el-input v-model="historyDetailForm.argument" :disabled="true" placeholder="请输入" type="textarea" style="width: 100%" />
          </el-descriptions-item>
          <el-descriptions-item label="附件：" :span="2">
            <FileComponent fileCode="settlementFile" :disabled="true" :files="files2" />
          </el-descriptions-item>
        </el-descriptions>

        <!-- 领导审批参数（历史弹窗内） -->
        <span style="font-size: 18px">领导审批参数</span>
        <el-descriptions v-if="taskType != 1" :column="2" border class="descriptions" label-width="200" style="margin-bottom: 24px;margin-top:12px">
          <el-descriptions-item v-if="taskType != 1" label="本次申请委托时间：" labelClassName="redFont">
            {{ historyDetailForm.leaderDeadlineDate }}
          </el-descriptions-item>
          <el-descriptions-item v-if="taskType != 1" label="本次申请累计委托量（m³）" labelClassName="redFont">{{
            historyDetailForm.leaderEntrustedVolume
          }}</el-descriptions-item>
          <el-descriptions-item v-if="taskType != 1" label="累计委托量（m³）" labelClassName="redFont">{{
            historyDetailForm.leaderCommissionedQuantity
          }}</el-descriptions-item>
        </el-descriptions>

        <!-- 核订单签订情况（历史弹窗内） -->
        <span style="font-size: 18px; margin-top: 24px">核订单签订情况</span>
        <el-table
          :header-cell-style="{ background: '#f3f6f9' }"
          :cell-style="{ borderRight: 'none' }"
          border
          stripe
          style="width: 100%; margin-top: 12px"
          tooltip-effect="dark"
          :data="nuclearOrderTableData"
        >
          <el-table-column label="结算周期" align="center" width="200">
            <template slot-scope="scope">
              {{ scope.row.lastDueTime }} ~ {{ scope.row.currentDueTime }}
            </template>
          </el-table-column>
          <el-table-column label="结算量" align="center" prop="settleAmount" width="120" />
          <el-table-column label="审核状态" align="center" width="120">
            <template slot-scope="scope">
              <span v-if="scope.row.settleStatus == 0">待结算</span>
              <span v-if="scope.row.settleStatus == 1">待审核</span>
              <span v-if="scope.row.settleStatus == 2">审核中</span>
              <span v-if="scope.row.settleStatus == 3">审核不通过</span>
              <span v-if="scope.row.settleStatus == 4">审核通过</span>
            </template>
          </el-table-column>
          <el-table-column label="附件" align="center">
            <template slot-scope="scope">
              <el-link v-if="scope.row.enclosureUrl" type="primary" :underline="false" @click="viewAttachment(scope.row.enclosureUrl)">查看附件</el-link>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="left" width="120">
            <template slot-scope="scope">
              <el-button size="mini" class="bottom_two" @click="openSettlementDetail(scope.row)">查看</el-button>
            </template>
          </el-table-column>
        </el-table>

        <FlowsNodeList :tableData="approveTableData" />
        <span slot="footer" class="dialog-footer">
          <el-button class="bottom_all_two" @click="historyDetailDig = false">关 闭</el-button>
        </span>
      </el-dialog>

      <!-- 管控参数弹窗 -->
      <ControlParamDialog :visible.sync="controlParamVisible" :rowData="currentRow" />
      <!-- 附件查看弹窗 -->
      <LookFile :visible.sync="lookFileVisible" :config="lookFileConfig" />
      <!-- 打印审批表弹窗 -->
      <PrintApprovalDialog
        :visible.sync="printApprovalVisible"
        :rowData="currentPrintRow"
        :companyName="currentCompanyName"
      />
      <!-- 结算详情弹窗（过程核定量） -->
      <settlement-detail-dialog
        v-model="settlementDetailVisible"
        :rowData="currentRowData"
      />
    </el-container>
  </div>
</template>

<script>
import FlowContent from '@/components/WorkFlow/flowContent'
import FlowHeader from '@/components/WorkFlow/flowHeader'
import FlowsNodeList from '@/components/WorkFlow/flowsNodeList'
import LookFile from '@/components/File/LookFile'
import ControlParamDialog from '@/views/platform/ICPS/internetSales/supplyManagement/preparatoryCommission/components/ControlParam'
import PrintApprovalDialog from '@/views/platform/ICPS/internetSales/supplyManagement/preparatoryCommission/components/PrintApproval'
import SettlementDetailDialog from '@/views/platform/ICPS/internetSales/supplyManagement/preparatoryCommission/components/SettlementDetail.vue'
import { getUserInfo } from '@/utils/auth.js'
import {
  DelegatedUpdateHistory,
  saveDelegatedHistory,
  DelegatedApprovalHandle,
  DelegatedHistoryById,
  queryDelegatedHistory,
  DelegatedSaveTaskMession,
  quryApplyData
} from '@/api/internetSales/supplyManagement.js'
import { getDicType } from '@/api/common.js'
import FileComponent from '@/views/platform/ICPS/internetSales/components/fileComponent'
import { getNodeList } from '@/api/task/flows'
import { backlogQueryByReceiptNumber } from '@/api/index'
import { safeDecodeURI } from '@/utils/utils.js'

export default {
  components: {
    FlowContent,
    FlowHeader,
    FileComponent,
    FlowsNodeList,
    LookFile,
    ControlParamDialog,
    PrintApprovalDialog,
    SettlementDetailDialog,
  },
  data() {
    return {
      type: 0,
      title: '解控申请单',
      billCode: '',
      billDate: '',
      taskTypeText: ['发起', '已保存', '审批中', '已完成', '撤销', '不通过'],
      applyPerson: '',
      taskStatus: 0,
      showSendVisible: false,
      readOnly: false,
      table: [
        { label: '日期', prop: 'dataMouth', status: true, width: '80', fixed: 'left' },
        { label: '财务编码', prop: 'financialCode', status: true, width: '220', fixed: 'left' },
        { label: '工程名称', prop: 'engineeringName', status: true, width: '280', fixed: 'left' },
        { label: '合同单位', prop: 'contractUnit', status: true, width: '220' },
        { label: '施工进度', prop: 'constructionProgress', status: true, width: 'auto' },
        { label: '本期项目产值', prop: 'currentProjectOutputValue', status: true, width: '100' },
        { label: '本期合同应收款', prop: 'currentContractReceivables', status: true, width: '110' },
        { label: '本期累计回款', prop: 'currentCumulativePaymentReceived', status: true, width: '100' },
        { label: '本期工程欠款', prop: 'currentEngineeringArrears', status: true, width: '100' },
        { label: '本期合同欠款', prop: 'currentContractArrears', status: true, width: '100' },
        { label: '上期合同应收款', prop: 'lastContractReceivables', status: true, width: '100' },
        { label: '实时累计回款', prop: 'realTimeCumulativeReal', status: true, width: '100' },
        { label: '偏差率X（%）', prop: 'deviationRateX', status: true, width: 'auto' },
        { label: '合同欠款绝对额Y', prop: 'contractArrearsAbsValue', status: true, width: 'auto' },
        { label: '欠款管控等级', prop: 'debtControlLevel', status: true, width: 'auto' }
      ],
      formData: {
        mainDataId: '',
        id: '',
        engineeringId: '',
        engineeringName: '',
        companyId: '',
        companyName: '',
        delegationType: '',
        delegationTypeId: '',
        entrustBeginTime: '',
        entrustEndTime: '',
        commissionedQuantity: 0,
        supplyQuantity: 0,
        firstSupplyTime: '',
        businesName: '',
        collaborationUnitName: '',
        coordinationSubject: '',
        discloseType: '',
        constructionProgress: '',
        saller: '',
        applyDeadlineDate: '',
        applyEntrustedVolume: '',
        argument: '',
        createTime: '',
        attachment: []
      },
      tableData: [],
      total: 0,
      files: [],
      historyDetailDig: false,
      historyDetailForm: {},
      files2: [],
      files4: [],
      processManagerId: '',
      processVersionId: '',
      processTaskId: '',
      approveTableData: [],
      removeControlTableData: [],
      nuclearOrderTableData: [],
      taskType: 1,
      confirmStatus: false,
      isLook: false,
      delegationTypeOptions: [],
      controlParamVisible: false,
      currentRow: {},
      lookFileVisible: false,
      lookFileConfig: { filePaths: '' },
      printApprovalVisible: false,
      currentPrintRow: {},
      currentCompanyName: '',
      // 结算详情弹窗
      settlementDetailVisible: false,
      currentRowData: {}
    }
  },
  methods: {
    // 格式化浇筑方式
    formatPourMethod(val) {
      if (!val) return '-'
      const data = typeof val === 'string' ? JSON.parse(val) : val
      if (Array.isArray(data)) {
        return data.map(item => item.name).filter(n => n).join(' / ') || '-'
      }
      if (data && data.name) {
        return data.name
      }
      return '-'
    },
    // 计算累计委托量
    calculateTotalCommissioned(base, add) {
      return (Number(base) || 0) + (Number(add) || 0)
    },
    // 正整数校验
    handlePositiveInteger(field, value) {
      let str = String(value || '')
      str = str.replace(/[^\d]/g, '')
      if (str === '') str = '0'
      let intVal = parseInt(str, 10)
      if (intVal < 0) intVal = 0
      this.formData[field] = intVal
    },
    // 委托类型变更
    handleDelegationTypeChange(val) {
      if (!val) {
        this.formData.delegationTypeId = ''
        return
      }
      const selectedOption = this.delegationTypeOptions.find(item => item.itemName === val)
      if (selectedOption) {
        this.formData.delegationTypeId = selectedOption.id
      } else {
        this.formData.delegationTypeId = ''
      }
    },
    // 加载委托类型字典
    loadDelegationTypes() {
      if (this.delegationTypeOptions.length) return Promise.resolve()
      return getDicType({ code: 'delegation_type' }).then(res => {
        if (res.code === 1001 && res.data && res.data.items) {
          this.delegationTypeOptions = res.data.items
        } else {
          this.$message.error('获取委托类型失败')
        }
      })
    },
    // 附件上传成功
    uploadSuccess(data) {
      const params = {
        fileName: data.fileName,
        filePath: data.fileUrl
      }
      this.files.push(params)
      this.formData.attachment = JSON.stringify(this.files)
    },
    // 删除附件
    deleteFile(index) {
      this.files.splice(index, 1)
      this.formData.attachment = JSON.stringify(this.files)
    },
    // 查看附件
    viewAttachment(enclosureUrl) {
      if (!enclosureUrl) return
      try {
        const files = JSON.parse(enclosureUrl)
        if (files && files.length) {
          this.lookFileConfig.filePaths = JSON.stringify(files)
          this.lookFileVisible = true
        } else {
          this.$message.info('无附件')
        }
      } catch (e) {
        this.$message.error('附件解析失败')
      }
    },
    // 查看管控参数
    lookMore() {
      this.currentRow = {
        companyId: this.formData.companyId,
        delegationTypeId: this.formData.delegationTypeId
      }
      this.controlParamVisible = true
    },
    sendProcessManagerId(processManagerId) {
      this.processManagerId = processManagerId
    },
    sendProcessVersionId(processVersionId) {
      console.log(processVersionId)
      this.processVersionId = processVersionId
      console.log('processVersionId----------------------' + processVersionId)
    },
    // 查看历史详情（核订单或历史流程）
    lookDetail(row) {
      console.log(row)
      this.historyDetailForm = row
      this.$set(this.historyDetailForm, 'leaderDeadlineDate', this.historyDetailForm.applyDeadlineDate)
      this.$set(this.historyDetailForm, 'leaderEntrustedVolume', this.historyDetailForm.applyEntrustedVolume)
      this.$set(this.historyDetailForm, 'leaderCommissionedQuantity', this.historyDetailForm.lastCommissionedQuantity)
      this.files2 = this.historyDetailForm.attachment ? JSON.parse(this.historyDetailForm.attachment) : []
      // 获取所有节点
      let params = {
        processManagerId: row.processManagerId,
        processTaskId: row.processTaskId,
        processVersionId: row.processVersionId
      }
      getNodeList(params).then(res => {
        if (res.code === 1001) {
          const newData = []
          res.data.forEach(item => {
            const data = {
              nodeName: item.nodeName,
              userName: item.instanceLogsList.map(sItem => sItem.userName),
              userId: item.instanceLogsList.map(sItem => sItem.userId),
              multiApprovalType: item.multiApprovalType,
              approvalOptions: item.instanceLogsList.map(sItem => sItem.approvalOptions),
              handlerTime: item.instanceLogsList.map(sItem => sItem.handlerTime),
              id: item.id,
              approvalStatus: item.approvalStatus,
              processInstanceId: item.processInstanceId,
              processInstanceNodeId: item.instanceLogsList.map(sItem => sItem.processInstanceNodeId)
            }
            newData.push(data)
          })
          this.approveTableData = newData
        }
      })
      this.historyDetailDig = true
    },
    // 打印审批表
    printApproval(row) {
      this.currentPrintRow = row
      this.currentCompanyName = row.companyName || this.formData.companyName || ''
      this.printApprovalVisible = true
    },
    // 打开结算详情弹窗
    openSettlementDetail(row) {
      this.currentRowData = {
        ...row,
        engineeringName: this.formData.engineeringName,
        engineeringId: this.formData.engineeringId,
      };
      this.settlementDetailVisible = true;
    },
    DelegatedUpdateHistory() {
      let obj = {
        mainDataId: this.formData.mainDataId,
        leaderDeadlineDate: this.formData.leaderDeadlineDate,
        leaderEntrustedVolume: this.formData.leaderEntrustedVolume,
        leaderCommissionedQuantity: this.formData.leaderCommissionedQuantity,
      }
      DelegatedUpdateHistory(obj)
    },
    // 1 不通过  2撤销
    resetFlowState(type) {
      if (type == 1) {
        const params = {
          process_success: {
            url: '/icps/system/sign/cloudSell/preCommissioning/approvalCallback',
            data: {
              mainDataId: this.formData.mainDataId,
              approvalStatus: 1
            },
            httpMethod: 'post'
          },
          process_failure: {
            url: '/icps/system/sign/cloudSell/preCommissioning/approvalCallback',
            data: {
              mainDataId: this.formData.mainDataId,
              approvalStatus: 3
            },
            httpMethod: 'post'
          }
        }
        this.$refs.flowcontent.handleToFlow(params)
      }
      if (type == 2) {
        DelegatedApprovalHandle({
          mainDataId: this.formData.mainDataId,
          approvalStatus: 4
        })
      }
      this.showSendVisible = false
    },
    async handleBusiness() {
      this.formData.leaderCommissionedQuantity = this.calculateTotalCommissioned(
        this.formData.commissionedQuantity,
        this.formData.leaderEntrustedVolume
      );
      console.log( "----------this.formData-------------232323---------")
      console.log( this.formData)
      DelegatedUpdateHistory({
        mainDataId: this.formData.mainDataId,
        leaderDeadlineDate: this.formData.leaderDeadlineDate,
        leaderEntrustedVolume: this.formData.leaderEntrustedVolume,
        leaderCommissionedQuantity: this.formData.leaderCommissionedQuantity,
      }).then(res => {
        if (res.code == 1001) {
          this.handleToFlow()
        }
      })
    },
    handleToFlow() {
      const params = {
        process_success: {
          url: '/icps/system/sign/cloudSell/preCommissioning/approvalCallback',
          data: {
            mainDataId: this.formData.mainDataId,
            approvalStatus: 1,
          },
          httpMethod: 'post'
        },
        process_failure: {
          url: '/icps/system/sign/cloudSell/preCommissioning/approvalCallback',
          data: {
            mainDataId: this.formData.mainDataId,
            approvalStatus: 3,
          },
          httpMethod: 'post'
        }
      }
      this.showSendVisible = false
      this.$refs.flowcontent.handleToFlow(params)
    },
    /**
     * @Description:
     * @Param: 1为保存时 status 为 processTaskId，2为最后提交/3中间提交 时 status 为2 通过 为3不通过
     */
    handleFinish(type, status) {
      console.log(type, status)
      if (type == 1) {
        saveDelegatedHistory(this.formData).then(res => {
          if (res.code == 1001) {
            DelegatedSaveTaskMession({
              mainDataId: this.formData.id,
              processManagerId: this.processManagerId,
              processTaskId: status,
              processVersionId: this.processVersionId,
              receiptNumber: this.billCode
            })
          }
        })
      }
    },
    async handleSubmit(type) {
      if (this.taskType != 1 && !this.confirmStatus && type == 2) {
        this.$message.warning('请确认领导审批参数!')
        return
      }
      this.formData.leaderCommissionedQuantity = this.calculateTotalCommissioned(
        this.formData.commissionedQuantity,
        this.formData.leaderEntrustedVolume
      );
      const { query } = this.$route
      if (query.type * 1 === 2 && type === 2 && query.taskType * 1 !== 2) {
        this.showSendVisible = true
        setTimeout(() => {
          let approvalOptions = '本次申请委托截止时间:' + (this.formData.leaderDeadlineDate + ', 本次申请累计委托量（m³）:' + this.formData.leaderEntrustedVolume + ', 累计委托量（m³）:' + this.formData.leaderCommissionedQuantity)
          this.$refs.flowcontent.setOperationModal(approvalOptions)
        }, 200)
        return
      }
      const data = {
        dataSource: 'PreCommissioningApproval',
        dataContent: JSON.stringify({ ...this.formData })
      }
      this.$refs.flowcontent.saveFlows(type, data)
    },
    handleCancel() {
      this.showSendVisible = false
    },
    /**
     * @Description: 发起流程时回显业务数据（type=1）
     */
    initFlowsData() {
      this.isReadOnly = true
      const { query } = this.$route
      console.log('initFlowsData', query)
      const data = JSON.parse(query.dataContent)
      console.log('🚀 data:', data)
      this.formData = data
      console.log('formData------------------', data)
      this.files = this.formData.attachment ? JSON.parse(this.formData.attachment) : []
      this.$set(this.formData, 'leaderDeadlineDate', this.formData.applyDeadlineDate)
      this.$set(this.formData, 'leaderEntrustedVolume', this.formData.applyEntrustedVolume)
      this.$set(this.formData, 'leaderCommissionedQuantity', this.formData.lastCommissionedQuantity)
      this.loadDelegationTypes()
      // 获取历史申请流程
      queryDelegatedHistory({ mainDataId: this.formData.id }).then(res => {
        if (res.code == 1001) {
          this.removeControlTableData = res.data.historyList
        }
      })
      // 加载核订单数据
      quryApplyData({ engineeringId: this.formData.engineeringId }).then(res => {
        if (res.code == 1001) {
          this.nuclearOrderTableData = res.data.processManageVos || []
        }
      })
    },
    /**
     * @Description: 审批/查看时回显业务数据（type=2）
     */
    initFlowsData2() {
      const { query } = this.$route
      this.formData = safeDecodeURI(JSON.parse(query.dataContent))
      this.title = query.taskName
      this.billCode = query.receiptNumber
      this.applyPerson = query.createUserName
      this.billDate = query.createTime
      this.taskStatus = query.taskStatus
      this.files = this.formData.attachment ? JSON.parse(this.formData.attachment) : []
      this.loadDelegationTypes()
      console.log('formData------------------', this.formData)
      DelegatedHistoryById({ mainDataId: this.formData.id }).then(res => {
        if (res.code == 1001) {
          this.formData = res.data
          if (!this.formData.leaderDeadlineDate && this.formData.applyDeadlineDate) {
              this.$set(this.formData, 'leaderDeadlineDate', this.formData.applyDeadlineDate)
          }
          if (!this.formData.leaderEntrustedVolume && this.formData.applyEntrustedVolume) {
            this.$set(this.formData, 'leaderEntrustedVolume', this.formData.applyEntrustedVolume)
          }
          if (!this.formData.leaderCommissionedQuantity && this.formData.lastCommissionedQuantity) {
            this.$set(this.formData, 'leaderCommissionedQuantity', this.formData.lastCommissionedQuantity)
          }
          this.files = this.formData.attachment ? JSON.parse(this.formData.attachment) : []
        }
      })
      queryDelegatedHistory({ mainDataId: this.formData.id }).then(res => {
        if (res.code == 1001) {
          this.removeControlTableData = res.data.historyList
        }
      })
      quryApplyData({ engineeringId: this.formData.engineeringId }).then(res => {
        if (res.code == 1001) {
          this.nuclearOrderTableData = res.data.processManageVos || []
        }
      })
      this.openWorkFlowInfo()
    },
    sendCode(code) {
      this.billCode = code
    },
    handleFlowChat() {
      this.$refs.flowcontent.showFlowNode()
    },
    // 查看审批情况
    openWorkFlowInfo() {
      console.log('查看审批情况', this.billCode)
      if (this.billCode) {
        backlogQueryByReceiptNumber(this.billCode).then(res => {
          if (res.code == 1001 && res.data) {
            let valData = res.data
            this.taskStatus = valData.taskStatus
            this.applyPerson = valData.createUserName
            this.billDate = valData.createTime
            if (this.taskStatus == 3 || this.taskStatus == 4 || this.taskStatus == 5) {
              this.readOnly = true
            }
          }
        })
      }
    }
  },
  mounted() {
    const { query } = this.$route
    this.taskType = query.type
    if (query.type == 1) {
      this.initFlowsData()
      this.title = '委托管控流程审核-' + this.formData.engineeringName
      this.applyPerson = getUserInfo().userRealName
      this.$refs.flowcontent.initBaseData('PreCommissioningApproval')
      this.billDate = new Date().Format('yyyy-MM-dd hh:mm:ss')
      this.formData.createUserName = this.applyPerson
      this.formData.createTime = this.billDate
      return
    }
    this.initFlowsData2()
    if (query.isReadOnly * 1 === 1) {
      this.readOnly = true
    }
  }
}
</script>

<style lang="scss" scoped>
.flows-details {
  margin-top: 20px;
}
.info {
  padding: 0 20px;
  background: #fff;
  .info-top {
    font-size: $font_size;
    color: #000000;
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 50px;
    border-bottom: 1px #e1e5ed solid;
    .left {
      display: flex;
      align-items: center;
    }
    .text {
      margin-left: 60px;
    }
  }
}
.nav_title {
  display: flex;
  align-items: center;
  align-items: flex-end;
  > div {
    width: 4px;
    height: 24px;
    background: $bg_color;
    margin-right: 10px;
  }
  i {
    margin-left: 5px;
  }
  color: $bg_color;
  font-size: 20px;
  font-weight: bold;
}
</style>

<style scoped>
.descriptions /**/ >>>/**/ .redFont {
  color: red !important;
}
.descriptions /**/ >>>/**/ .textClass {
  width: 450px;
}
.descriptions /**/ >>>/**/ .textClass2 {
  width: 300px;
}
</style>